import React, { FunctionComponent } from "react";

export const HeroImageComponent: FunctionComponent = (props: any) => {
  return (
    <img style={{ width: "100%" }} src={props.blockProps.url} alt="source" />
  );
};
